// Net Worth (CR-5) = liquid Mao Coin + appreciated real estate.
// Each asset appreciates 15%/REAL-calendar-year from when it was acquired
// (purchasedAt; starter assets fall back to the profile's joinedAt). The home
// is valued by its level (shack base vs the manor upgrade); every other owned,
// non-wild plot counts as a LAND parcel; buildings add their own value on top.

import { active, getProfile } from './state.js'
import { getWealth } from './seasonManager.js'
import { computeRealEstateValue } from './netWorthCalc.js'

// Appreciated value of all real estate in the active kingdom (the maths lives in netWorthCalc.js, shared with the server's Registry).
export function getRealEstateValue() {
  return computeRealEstateValue(active(), getProfile().joinedAt || Date.now())
}

// Headline Net Worth = liquid coin + appreciated real estate.
export function getNetWorth() {
  return Math.round(getWealth() + getRealEstateValue())
}
